import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Button } from '@grandvisionhq/common';

const RemoveButton = (props)=>/*#__PURE__*/ React.createElement(Button, swcHelpers.extends({
        size: "custom",
        "data-t": "remove-button",
        className: "remove-button",
        variant: "ghost"
    }, props))
;

export { RemoveButton };
//# sourceMappingURL=RemoveButton.js.map
